import React from 'react'
import parse from 'html-react-parser'
import * as E from '../elementor'
import SmoothScrollLink from './transition/smooth-scroll-link'

interface Props {
  section?: E.Section
}

const HalfAndHalfHero: React.FC<Props> = ({ section }) => {
  const { heading = [], textEditor = [], button = [], image = [] } = (section != null) ? E.collect(section) : {}
  
  return (
    <header className='half-and-half-hero' id='half-and-half-hero'>
      <div className='hero-content-wrapper'>
        <h1 className='hero-headline'>
          {parse(heading[0]?.title)}
        </h1>
        <p className='hero-features large'>
          {textEditor[0]?.parse()}
          {textEditor[1]?.parse()}
        </p>
        <div className='hero-cta-wrapper'>
          <a
            id={button[0]?.button_css_id || ""}
            href={button[0]?.link}
          >
            <button className="rula-button">
              {button[0]?.text || "Get Started"}
            </button>
          </a>
          <SmoothScrollLink
            id={button[1]?.link || '#how-it-works'}
            link_id={button[1]?.button_css_id}
            offset={0}
            offsetMobile={0}
            className='rula-secondary-button'
          >
            <p className={button[1]?.cssId}>{button[1]?.text ?? 'How does it work?'}</p>
          </SmoothScrollLink>
        </div>
      </div>
      <div className='img-wrapper'>
        <div className='inner-container'>
          <div>
            {image[0]?.image && <img src={image[0].image.fileUrl} />}
          </div>
        </div>
      </div>
    </header>
  )
};

export default HalfAndHalfHero
